import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, Fragment } from 'react/jsx-runtime';
import { Children, isValidElement, cloneElement, useEffect } from 'react';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { SteppedFormProvider, useSteppedForm } from './SteppedFormProvider.js';
import { SteppedFormStep } from './SteppedFormStep.js';

const SteppedFormContainer = ({
  customRenderer,
  children,
  onStepChange
}) => {
  const steps = Children.map(children, (child, stepIndex) => {
    if (isValidElement(child) && child.type === SteppedFormStep) {
      return cloneElement(child, {
        stepIndex
      });
    }
    return child;
  });
  const {
    activeStepIndex,
    isFirstStep,
    isLastStep
  } = useSteppedForm();
  useEffect(() => onStepChange === null || onStepChange === void 0 ? void 0 : onStepChange(activeStepIndex), [activeStepIndex, onStepChange]);
  return jsx(Fragment, {
    children: (customRenderer === null || customRenderer === void 0 ? void 0 : customRenderer({
      steps,
      activeStepIndex,
      isFirstStep,
      isLastStep
    })) || steps
  });
};
const SteppedForm = /*#__PURE__*/withTitan(_a => {
  var {
      children,
      customRenderer,
      onStepChange
    } = _a,
    rest = __rest(_a, ["children", "customRenderer", "onStepChange"]);
  const totalSteps = Children.toArray(children).filter(child => isValidElement(child) && child.type === SteppedFormStep).length;
  return jsx(SteppedFormProvider, Object.assign({
    totalSteps: totalSteps
  }, rest, {
    children: jsx(SteppedFormContainer, {
      customRenderer: customRenderer,
      onStepChange: onStepChange,
      children: children
    })
  }));
}, {
  name: 'SteppedForm'
});

export { SteppedForm };
//# sourceMappingURL=SteppedForm.js.map
